import { render, staticRenderFns } from "./ProjectPieChart.vue?vue&type=template&id=d4a4c730&scoped=true&"
import script from "./ProjectPieChart.vue?vue&type=script&lang=js&"
export * from "./ProjectPieChart.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPieChart.vue?vue&type=style&index=0&id=d4a4c730&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a4c730",
  null
  
)

export default component.exports